/* import __COLOCATED_TEMPLATE__ from './number-configuration.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';
import { action } from '@ember/object';

interface Args {
  ruleset: $TSFixMe;
  hasContentReadyForFin: boolean;
  phoneNumberId?: string;
  numberConfiguration?: FinVoiceNumberConfiguration;
  updatePercentageRollout: (
    phoneNumber: string,
    rollOutPercentageIn: number | undefined,
    rollOutPercentageNin: number | undefined,
  ) => Promise<void>;
  resetSelectedLine: () => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class NumberConfiguration extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;

  get phoneNumbers() {
    return this.finVoiceConfigService.phoneNumbers;
  }

  get phoneNumber() {
    if (!this.args.phoneNumberId) {
      return undefined;
    }

    return this.finVoiceConfigService.phoneNumbers[this.args.phoneNumberId];
  }

  get isExternalProvider(): boolean {
    return this.phoneNumber?.isExternalProvider || false;
  }

  @action getHeaderLabel() {
    if (!this.args.phoneNumberId) {
      return '';
    }

    let phoneNumberRecord = this.phoneNumbers[this.args.phoneNumberId];

    if (!phoneNumberRecord) {
      return this.args.phoneNumberId;
    }

    if (phoneNumberRecord.name) {
      if (this.isExternalProvider) {
        return this.intl.t(
          'operator.fin.setup.tabs.setup-and-go-live.phone.workspace-phone-number.external-phone-number-label',
          {
            phoneName: phoneNumberRecord.name,
            phoneNumber: phoneNumberRecord.phoneNumber,
          },
        );
      } else {
        return this.intl.t(
          'operator.fin.setup.tabs.setup-and-go-live.phone.workspace-phone-number.internal-phone-number-label',
          {
            phoneName: phoneNumberRecord.name,
            phoneNumber: phoneNumberRecord.phoneNumber,
          },
        );
      }
    }

    return phoneNumberRecord.phoneNumber;
  }

  @action resetSelectedLine() {
    this.args.resetSelectedLine();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::NumberConfiguration': typeof NumberConfiguration;
  }
}
